"use client"
import { useIsDesktop } from "common/MediaQueries"
import NextLink from "common/bit/NextLink"
import reactStringReplace from "react-string-replace"
import InnerPageWrapper from "reusable/wrappers/InnerPageWrapper"
import styled from "styled-components"
import { StyledSvgIcon, TypographyCenter } from "theme/shared"
import { insuranceData } from "./InsuranceData"
import InsuranceForm from "./InsuranceForm"

const StyledCardsWrapper = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  margin: 20px 0px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 45px 0px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: auto;
    justify-items: center;
  }
`
const StyledCardWrap = styled.div`
  display: flex;
  padding: 16px;
  gap: 16px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: column;
    align-items: center;
    width: 248px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    /* not last child */
    &:not(:last-child) {
      border-bottom: 0.5px solid ${(p) => p.theme.colors.darkGrey};
    }
    padding: 25px 10px;
  }
`

const StyledNextLink = styled(NextLink)`
  text-decoration: underline;
  color: ${(p) => p.theme.colors.saphire};
`

const StyledDetailsContainer = styled.div`
  margin-top: 15px;
`

const StyledText = styled(TypographyCenter)<{ $lineHeight?: number }>`
  font-family: "OENaPro";
  line-height: ${(p) => (p.$lineHeight ? `${p.$lineHeight}%` : "")};
`

const InsurancePage = () => {
  const isDesktop = useIsDesktop()
  return (
    <InnerPageWrapper
      title="ביטוח בתנאים מיוחדים ללקוחות מאזדה"
      imgUrl={isDesktop ? "/img/insurance.jpg" : "/img/insurancemobile.jpg"}
      breadCrumbName="Insurance"
      paddingBottom={"0"}
    >
      <StyledText variant="body1" $mobileRtl $mb="26px" $fontSize="20px">
        באמצעות דלק מוטורס סוכנות לביטוח (2003) בע״מ
      </StyledText>
      <StyledText variant="body1" $mobileRtl>
        כל מה שצריך בשביל ליהנות מראש שקט לאורך כל הדרך.
      </StyledText>

      <StyledText variant="h2" $mobileRtl $fontSize="18px">
        תכנית הביטוח מיועדת לרוכשי מכוניות מתוצרת מאזדה וכוללת בין היתר:
      </StyledText>
      <StyledCardsWrapper>
        {insuranceData.map((item, index) => (
          <StyledCardWrap key={index}>
            <StyledSvgIcon
              src={item.iconPath}
              $w={30}
              $h={30}
              role="presentation"
              aria-hidden="true"
            />
            <div>
              <StyledText variant="h3" $mobileRtl>
                {item.title}
              </StyledText>
              <StyledText variant="body1" $lineHeight={130} $mobileRtl>
                {reactStringReplace(
                  item.text,
                  "במרכזי השירות המורשים",
                  (match, i) => (
                    <StyledNextLink
                      key={i}
                      href={"/services-centers/?popup=open"}
                    >
                      {match}
                    </StyledNextLink>
                  )
                )}
              </StyledText>
            </div>
          </StyledCardWrap>
        ))}
      </StyledCardsWrapper>
      {/* information: */}

      <StyledText variant="h2" $mobileRtl $fontSize="20px">
        כפוף לתנאי הפוליסה
      </StyledText>
      <StyledText variant="h2" $mt="10px" $mobileRtl $fontSize="18px">
        במקרה של תאונה/גניבה יש לפנות למוקד תביעות של דלק מוטורס ביטוח.
      </StyledText>
      <StyledDetailsContainer>
        <StyledText variant="body1" $mobileRtl>
          טלפון:{` `}
          <StyledNextLink href="tel:077-7552215">077-7552215</StyledNextLink>
        </StyledText>
        <StyledText variant="body1" $mobileRtl>
          פקס:{` `}
          153-777-552202
        </StyledText>
        <StyledText variant="body1" $mobileRtl>
          דואל:{` `}
          <StyledNextLink href="mailto:service1@delekmotors.co.il">
            service1@delekmotors.co.il
          </StyledNextLink>
        </StyledText>
      </StyledDetailsContainer>
      {/* form: */}
      <InsuranceForm />
    </InnerPageWrapper>
  )
}

export default InsurancePage
